import React, { Component } from "react";

const ShoppingCartIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9565 3.52175L17.6304 10.8696C17.4565 11.3913 17 11.7392 16.4565 11.7392H7.47826C6.95652 11.7392 6.45652 11.413 6.28261 10.9348L2.86957 1.73915H0.869565C0.391304 1.73915 0 1.34785 0 0.869587C0 0.391326 0.391304 2.12296e-05 0.869565 2.12296e-05H3.45652C3.82609 2.12296e-05 4.15218 0.239141 4.28261 0.586967L7.82609 9.97826H16.087L17.9348 4.1087H7.69565C7.21739 4.1087 6.82609 3.71739 6.82609 3.23913C6.82609 2.76087 7.21739 2.36957 7.69565 2.36957H19.1304C19.413 2.36957 19.6739 2.52173 19.8261 2.73912C20 2.95651 20.0435 3.26088 19.9565 3.52175ZM7.91304 12.8696C7.54348 12.8696 7.17391 13.0217 6.91304 13.2826C6.65217 13.5435 6.5 13.9131 6.5 14.2826C6.5 14.6522 6.65217 15.0217 6.91304 15.2826C7.17391 15.5435 7.54348 15.6957 7.91304 15.6957C8.28261 15.6957 8.65217 15.5435 8.91304 15.2826C9.17391 15.0217 9.32609 14.6522 9.32609 14.2826C9.32609 13.9131 9.17391 13.5435 8.91304 13.2826C8.65217 13.0217 8.28261 12.8696 7.91304 12.8696ZM15.7174 12.8696C15.3478 12.8696 14.9783 13.0217 14.7174 13.2826C14.4565 13.5435 14.3043 13.9131 14.3043 14.2826C14.3043 14.6522 14.4565 15.0217 14.7174 15.2826C14.9783 15.5435 15.3478 15.6957 15.7174 15.6957C16.087 15.6957 16.4565 15.5435 16.7174 15.2826C16.9783 15.0217 17.1304 14.6522 17.1304 14.2826C17.1304 13.9131 16.9783 13.5435 16.7174 13.2826C16.4565 13.0217 16.087 12.8696 15.7174 12.8696Z"
        fill={fill}
      />
    </svg>
  );
};
ShoppingCartIcon.defaultProps = {
  width: 20,
  height: 16,
  fill: "white",
};
export default ShoppingCartIcon;
